module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[23]266.f22d5f0.woff2";